import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddPromocodeComponent } from './add-promocode/add-promocode.component';
import { PromocodeManagementComponent } from './promocode-management/promocode-management.component';
import { PromocodeModalComponent } from './promocode-modal/promocode-modal.component';
import { PromocodeRoutingModule } from './promocode-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    AddPromocodeComponent,
    PromocodeManagementComponent,
    PromocodeModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PromocodeRoutingModule,
    MatDialogModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
})
export class PromocodeModule {}
